<style scoped>
  .page-block {
    text-align: center;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -50px;
    margin-left: -50px;
  }
  .comment-block {
    text-align: center;
    margin: 15px;
  }
  /* img {
    opacity: 0.5;
    filter: alpha(opacity=50);
  } */
</style>

<template>
  <div>
    <div class="comment-block" v-if="type=='comment-block'">
      <img alt=" " src="@/assets/comment.png">
      <p><slot></slot></p>      
    </div>    
    <div class="page-block" v-if="type=='page-block'">
      <img alt=" " src="@/assets/comment.png">
      <p><slot></slot></p>
    </div>    
  </div>
</template>

<script>

export default {
  name: 'BeFirstToComponent', 
  props: {
    type: String, required: false, default: "page-block"
  }
}

</script>
